import React, { useEffect, useState } from 'react';
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const Alumni = () => {
  useEffect(() => {
    document.title = 'Alumni -  The Air Force School Subroto Park';
  }, []);
  const [successMessage, setSuccessMessage] = useState("");
  const [submitStatus, setSubmitStatus] = useState("idle");
  const [formData, setFormData] = useState({

    toYear :"",
    class :"",
 name :"",
    email :"",
    phone :"",
    location :"" ,
    address :"",
    school :"",
    profession3 :"",
    fromYear :"",
    subject :"",
    profession1 :"",
    school1 :"",
    designation :"",
    address1 :""
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear the error for the field being changed

  };

  const validateForm = () => {
    const newErrors = {};
    const hasSpecialChars = str => /[!@#$%^&*()_+=,.?":{}|<>]/g.test(str);
    const hasNumbersOnly = str => /^\d+$/.test(str);
    const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhone = phone => /^\d{10}$/.test(phone); // Adjust for your format

    if (!formData.name || formData.name.trim() === "") {
      newErrors.name = "Name is required.";
    } else if (hasSpecialChars(formData.name)) {
      newErrors.name = "Name should not contain special characters.";
    }

    if (!formData.address || formData.address.trim() === "") {
      newErrors.address = "Address is required.";
    }

    if (!formData.class || formData.class.trim() === "") {
      newErrors.class = "Last Class is required.";
    }

    if (!formData.toYear || formData.toYear.trim() === "") {
      newErrors.toYear = "Batch is required.";
    }

    if (!formData.email || formData.email.trim() === "") {
      newErrors.email = "Email is required.";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Email format is invalid.";
    }
    if (!formData.profession1 || formData.profession1.trim() === "") {
      newErrors.profession1 = "Profession is required.";
    }

    if (!formData.location || formData.location.trim() === "") {
      newErrors.location = "Location is required.";
    } else if (hasSpecialChars(formData.location)) {
      newErrors.location = "Location should not contain special characters.";
    }
    if (!formData.school || formData.school.trim() === "") {
      newErrors.school = "College is required.";
    } else if (hasSpecialChars(formData.school)) {
      newErrors.school = "College should not contain special characters.";
    }

    if (!formData.profession3 || formData.profession3.trim() === "") {
      newErrors.profession3 = "Degre is required.";
    } else if (hasSpecialChars(formData.profession3)) {
      newErrors.profession3 = "Degre should not contain special characters.";
    }

    if (!formData.subject || formData.subject.trim() === "") {
      newErrors.subject = "Stream is required.";
    } else if (hasSpecialChars(formData.subject)) {
      newErrors.subject = "Stream should not contain special characters.";
    }

    if (!formData.school1 || formData.school1.trim() === "") {
      newErrors.school1 = "Organisation Name is required.";
    } else if (hasSpecialChars(formData.school1)) {
      newErrors.school1 = "Organisation Name should not contain special characters.";
    }
    if (!formData.fromYear || formData.fromYear.trim() === "") {
      newErrors.fromYear = "Sem / Year is required.";
    } else if (!hasNumbersOnly(formData.fromYear)) {
      newErrors.fromYear = "Sem / Year should not contain special characters.";
    }
    if (!formData.designation || formData.designation.trim() === "") {
      newErrors.designation = "Designation is required.";
    } else if (hasSpecialChars(formData.designation)) {
      newErrors.designation = "Designation should not contain special characters.";
    }

    if (!formData.address1 || formData.address1.trim() === "") {
      newErrors.address1 = "Office Address is required.";
    } else if (hasSpecialChars(formData.address1)) {
      newErrors.address1 = "Office Address should not contain special characters.";
    }

    if (!formData.phone || formData.phone.trim() === "") {
      newErrors.phone = "Mobile is required.";
    } else if (!isValidPhone(formData.phone)) {
      newErrors.phone = "Phone number should be 10 digits.";
    }

    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSubmitStatus("idle");
      return;
    }

    setSubmitStatus("submitting");

    const processFile = async (file) => {
      if (!file) return null;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve({ name: file.name, type: file.type, data: reader.result.split(",")[1] });
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };

    try {
      const fileData = await processFile(formData.attachments1);
      const dataToSend = { ...formData, attachments1: fileData };

      console.log("Submitting form data:", dataToSend);

      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzYXAwcxFRyAfSTD11-_vn0JjHOaoTrYEZvZxFf0hN3KPMSAs5wxCjWK7KpNUQH09lp/exec",
        {
          mode: "no-cors",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        }
      );

    } catch (error) {
      console.error("Submission error:", error);
      setSubmitStatus("idle");
      return;
    }

    setTimeout(() => {
      setSubmitStatus("submitted");
      setSuccessMessage("Your Form Submitted Successfully.");
      setFormData({
        toYear :"",
        class :"",
     name :"",
        email :"",
        phone :"",
        location :"" ,
        address :"",
        school :"",
        profession3 :"",
        fromYear :"",
        subject :"",
        profession1 :"",
        school1 :"",
        designation :"",
        address1 :"" 
      });
    }, 5000);
  };
  // const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     const validationErrors = validateForm();
  //     if (Object.keys(validationErrors).length > 0) {
  //         setErrors(validationErrors);
  //         return;
  //     }

  //     const type = 'XYZ'; 
  //     console.log('Submitting form with type:', type); // Debugging line

  //     try {
  //         const { header } = getHeader(); // Make sure this function returns the correct headers
  //         const response = await form1(formData, header, type); 
  //         console.log('Form submitted successfully', response);
  //         setSuccessMessage("Your Form Submitted Successfully.");
  //         setFormData({
  //             name :"",
  //             address :"",
  //             class :"",
  //             toYear :"",
  //             email :"",
  //             profession1:"",
  //             location:"",
  //             phone :"",
  //             school:"",
  //             profession3:"",
  //             fromYear:"",
  //             subject:"",
  //             school1:"",
  //             designation:"",
  //             address1:"",
  //         });
  //     } catch (error) {
  //         console.error('Error submitting form:', error);
  //     }
  // };

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li>
          <li> Alumni Form  </li>

        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Alumni  Form</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <form onSubmit={handleSubmit}>
                <div className="mainform">
                  <h6>Kindly select the batch/session and class you last attended at school</h6>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label"> Batch <span>*</span></label>
                        <select className="form-control" name="toYear" value={formData.toYear} onChange={handleChange}>
                          <option value="">- Select -</option><option value="2023-2024">2023-2024</option>
                          <option value="2022-2023">2022-2023</option>
                          <option value="2021-2022">2021-2022</option>
                          <option value="2020-2021">2020-2021</option>
                          <option value="2019-2020">2019-2020</option>
                          <option value="2018-2019">2018-2019</option><option value="2017-2018">2017-2018</option> <option value="2016-2017">2016-2017</option> <option value="2015-2016">2015-2016</option> <option value="2014-2015">2014-2015</option> <option value="2013-2014">2013-2014</option> <option value="2012-2013">2012-2013</option> <option value="2011-2012">2011-2012</option> <option value="2010-2011">2010-2011</option> <option value="2009-2010">2009-2010</option> <option value="2008-2009">2008-2009</option> <option value="2007-2008">2007-2008</option> <option value="2006-2007">2006-2007</option> <option value="2005-2006<">2005-2006</option> <option value="2004-2005">2004-2005</option> <option value="2003-2004">2003-2004</option> <option value="2002-2003">2002-2003</option> <option value="2001-2002">2001-2002</option> <option value="2000-2001">2000-2001</option> <option value="1999-2000">1999-2000</option> <option value="1998-1999">1998-1999</option> <option value="1997-1998">1997-1998</option> <option value="1996-1997">1996-1997</option> <option value="1995-1996">1995-1996</option> <option value="1994-1995">1994-1995</option> <option value="1993-1994">1993-1994</option> <option value="1992-1993">1992-1993</option> <option value="1991-1992">1991-1992</option> <option value="1990-1991">1990-1991</option> <option value="1889-1990">1889-1990</option> <option value="1988-1989">1988-1989</option> <option value="1987-1988">1987-1988</option> <option value="1986-1987">1986-1987</option> <option value="1985-1986">1985-1986</option> <option value="1984-1985">1984-1985</option> <option value="1983-1984">1983-1984</option> <option value="1982-1983">1982-1983</option> <option value="1981-1982">1981-1982</option> <option value="1980-1981">1980-1981</option> <option value="1979-1980">1979-1980</option> <option value="1978-1979">1978-1979</option> <option value="1977-1978">1977-1978</option> <option value="1976-1977">1976-1977</option> <option value="1975-1976">1975-1976</option> <option value="1974-1975">1974-1975</option> <option value="1973-1974">1973-1974</option> <option value="1972-1973">1972-1973</option> <option value="1971-1972">1971-1972</option> <option value="1970-1971">1970-1971</option>

                        </select>
                      </div>
                      {errors.toYear && <div className="error">{errors.toYear}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label"> Last Class <span>*</span></label>
                        <select className="form-control" name="class" value={formData.class} onChange={handleChange} >
                          <option value="">- Select -</option>
                          <option value="I">I</option>
                          <option value="II">II</option>
                          <option value="III">III</option>
                          <option value="IV">IV</option>
                          <option value="V">V</option>  
                          <option value="VI">VI</option> 
                          <option value="VII">VII</option> 
                          <option value="VIII">VIII</option> 
                          <option value="IX">IX</option> 
                          <option value="X">X</option> 
                          <option value="XI">XI</option> 
                          <option value="XII">XII</option>
                        </select>
                      </div>
                      {errors.class && <div className="error">{errors.class}</div>}
                    </div>
                  </div>
                  <h6>Personal Details</h6>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Name <span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.name && <div className="error">{errors.name}</div>}

                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Email <span>*</span></label>
                        <input
                          type="text"
                          name="email"
                          className="form-control"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.email && <div className="error">{errors.email}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Mobile <span>*</span></label>
                        <input
                          type="text"
                          name="phone"
                          className="form-control"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.phone && <div className="error">{errors.phone}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label"> Location (City) <span>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.location && <div className="error">{errors.location}</div>}
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="form-label"> Permanent  Address <span>*</span> </label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.address && <div className="error">{errors.address}</div>}
                    </div>
                  </div>
                  <h6>Education Details</h6>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">College *</label>
                        <input
                          type="text"
                          name="school"
                          className="form-control"
                          value={formData.school}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.school && <div className="error">{errors.school}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Degree *</label>
                        <input
                          type="text"
                          name="profession3"
                          className="form-control"
                          value={formData.profession3}
                          onChange={handleChange}
                        />

                      </div>
                      {errors.profession3 && <div className="error">{errors.profession3}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Sem / Year *</label>
                        <input
                          type="text"
                          name="fromYear"
                          className="form-control"
                          value={formData.fromYear}
                          onChange={handleChange}
                        />

                      </div>
                      {errors.fromYear && <div className="error">{errors.fromYear}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Stream *</label>
                        <input
                          type="text"
                          name="subject"
                          className="form-control"
                          value={formData.subject}
                          onChange={handleChange}
                        />

                      </div>
                      {errors.subject && <div className="error">{errors.subject}</div>}
                    </div>
                  </div>
                  <h6>Employment Details</h6>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label"> Profession *</label>
                        <select
                          className="form-control"
                          name="profession1"
                          value={formData.profession1}
                          onChange={handleChange}
                        >
                          <option value="">-Select-</option>
                          <option value="Accounting">Accounting</option>
                          <option value="Agriculture">Agriculture</option>
                          <option value="Architecture">Architecture</option>
                          <option value="Aviation">Aviation</option>
                          <option value="Banking">Banking</option>
                          <option value="Business Services">Business Services</option>
                          <option value="Consulting">Consulting</option>
                          <option value="Education">Education</option>
                          <option value="Trading">Trading</option>
                          <option value="Manufacturing">Manufacturing</option>
                          <option value="Import/ Export">Import/ Export</option>
                          <option value="Retail">Retail</option>
                          <option value="Defense">Defense</option>
                          <option value="Engineering">Engineering</option>
                          <option value="Entertainment">Entertainment</option>
                          <option value="Fashion">Fashion</option>
                          <option value="Finance">Finance</option>
                          <option value="Home Maker">Home Maker</option>
                          <option value="Hospitality">Hospitality</option>
                          <option value="IT">IT</option>
                          <option value="Law">Law</option>
                          <option value="Media">Media</option>
                          <option value="Medicine">Medicine</option>
                          <option value="Politics">Politics</option>
                          <option value="Retired">Retired</option>
                          <option value="Scientist">Scientist</option>
                          <option value="Service Govt. Pvt.">Service Govt. Pvt.</option>
                          <option value="Social Work">Social Work</option>
                          <option value="Student">Student</option>
                          <option value="Travel and Tourism">Travel and Tourism</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      {errors.profession1 && <div className="error">{errors.profession1}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Organisation Name *</label>
                        <input
                          type="text"
                          name="school1"  
                          className="form-control"
                          value={formData.school1}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.school1 && <div className="error">{errors.school1}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Designation *</label>
                        <input
                          type="text"
                          name="designation"
                          className="form-control"
                          value={formData.designation}
                          onChange={handleChange}
                        />

                      </div>
                      {errors.designation && <div className="error">{errors.designation}</div>}
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Office Address</label>
                        <input
                          type="text"
                          name="address1"
                          className="form-control"
                          value={formData.address1}
                          onChange={handleChange}
                        />

                      </div>
                      {errors.address1 && <div className="error">{errors.address1}</div>}
                    </div>
                  </div>
                </div>
                <input
                  type="submit"
                  value={
                    submitStatus === "submitting"
                      ? "Submitting..."
                      : submitStatus === "submitted"
                        ? "Submitted"
                        : "Submit"
                  }
                  disabled={submitStatus === "submitting" || submitStatus === "submitted"}
                />
                <div class="row">
                  <div className="row primarydiv">
                    <div className="col-lg-12 col-md-12">
                      {successMessage && <div className='primary-alert'>{successMessage}</div>}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Alumni
